import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { ShopProvider } from "./context/ShopContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import AuthCallback from "./components/AuthCallback";
import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import ProductDetail from "./pages/ProductDetail";
import FitStudio from "./pages/FitStudio";
import Cart from "./pages/Cart";
import Login from "./pages/Login";
import Account from "./pages/Account";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Admin from "./pages/Admin";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <div data-testid="not-found-page" className="min-h-screen pt-40 pb-32 text-center px-6">
      <div className="font-script text-6xl text-sunkissed mb-4">Lost at sea</div>
      <h1 className="font-serif text-4xl font-light">This page drifted away</h1>
      <p className="text-charcoal/60 mt-3">The page you're looking for doesn't exist.</p>
      <Link to="/" className="inline-flex items-center gap-3 bg-ocean text-sand px-8 py-4 overline mt-8 hover:opacity-90 transition-opacity">
        Back to shore
      </Link>
    </div>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
}

function AppInner() {
  const location = useLocation();
  // Handle Emergent OAuth callback (session_id in URL fragment) before anything else.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/women" element={<Catalog gender="women" />} />
          <Route path="/men" element={<Catalog gender="men" />} />
          <Route path="/swimwear" element={<Catalog />} />
          <Route path="/product/:slug" element={<ProductDetail />} />
          <Route path="/fit-studio" element={<FitStudio />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/account" element={<Account />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ShopProvider>
          <BrowserRouter>
            <ScrollToTop />
            <AppInner />
            <Toaster position="bottom-right" theme="light" />
          </BrowserRouter>
        </ShopProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
